import { IBannerDetailsMediaComponent } from "./media/banner-details-media.component";
import { BannerDetailsMediaFactory } from "./media/banner-details-media.factory";
import { BannerAreaModel } from "./models/banner.model";

export class BannerAreaComponent {
    private _currentContext: JQuery = $();

    private _currentBanner: BannerAreaModel = null;

    private _media: IBannerDetailsMediaComponent = null;
    private _mediaFactory: BannerDetailsMediaFactory = null;

    public get id(): string {
        return this._currentBanner.id;
    }

    public getDomElement(): HTMLElement {
        return this._currentContext.get(0);
    }

    public setBanner(banner: BannerAreaModel): BannerAreaComponent {
        this._currentBanner = banner;
        return this;
    }

    public destroy(): void {
        if (this._media) {
            this._media.dispose();
        }
    }

    public initMedia(): void {
        const mediaFactoryContext = $(BannerDetailsMediaFactory.MEDIA_SELECTOR, this._currentContext);
        this._mediaFactory = new BannerDetailsMediaFactory();

        this._media = this._mediaFactory.getBrandDetailsMedia(mediaFactoryContext);
    }

    public render(): JQuery {
        this._currentContext = $(this._currentBanner.markup);

        return this._currentContext;
    }
}
